import React from 'react'
import CompLinkHeaders from 'components/riwayat/compLinkHeader'
import {Container, Row, Col} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import './style.css'
import Navbar from 'components/dashboard/navbar'
import Footer from 'components/dashboard/footer'

export default function referral() {
    return (
        <>
         <Navbar />
            <Container className="comp-page-referral">
                <CompLinkHeaders to="/profile" back="Profil Saya" title="Referral" Ctitle="referral-page" />
                <div className="text-refferal-group">
                    <p>Kode Referral Anda</p>
                    <h3>muhammad.p2w</h3>
                    <div className="text-referral">
                        <small><img src="asset/users/file-copy.svg" alt="copy" /> Salin Kode Referral</small>
                        <small><img src="asset/users/referral_add.svg" alt="plus" /> Ajak Teman</small>
                    </div>
                </div>
                <Row>
                    <Col md={6} className="Bonus-referral">
                        <p>Total Bonus Referral</p>
                        <h3>Rp. 200.000,-</h3>
                    </Col>
                    <Col md={6} className="Bonus-referral">
                        <p>Jumlah Referral</p>
                        <h3>1</h3>
                    </Col>
                </Row>
                <h6>Detail Referral</h6>
                <div className="tabel-profile-referral">
                    <div className="tabel-referral">
                        <div className="profile">
                            <img src="asset/users/referral-profile.png" alt="profile" />
                            <div className="text-name">
                                <p>Muhammad Hafiduddin</p>
                                <small>Makassar, Sulawesi Selatan</small>
                            </div>
                        </div>
                        <div className="bonus">
                            <p>Total Bonus Referral</p>
                            <h6>Rp. 200.000</h6>
                        </div>
                    </div>
                    <div className="border"></div>
                </div>
                <div className="any-quetion">
                    <p>Bingung dengan sistem Referral?</p>
                    <Link to="#">Lihat Panduannya Disini</Link>
                </div>
            </Container>
          <Footer />
        </>
    )
}
